import { useMemo } from "react";
import DailyView from "./daily-view";
import WeeklyView from "./weekly-view";
import CalendarHeader from "./calendar-header";
import useCalendarStore from "@/store/calendar-store";
import WeeklyAgendaView from "./agenda-weekly-view";
import type { ClassSession } from "@/types/ClassSession";

interface BaseCalendarViewProps {
  classSessions: ClassSession[];
  onEventClick: (event: any) => void;
  onWaitlistJoin?: (event: any) => void;
  handleIconClick?: (drawer: string | null) => void;
  isLoading: boolean;
}

const BaseCalendarView = ({
  classSessions,
  onEventClick,
  onWaitlistJoin,
  handleIconClick,
  isLoading,
}: BaseCalendarViewProps) => {
  const { view } = useCalendarStore();

  // OPTIMIZATION: Memoize to avoid rerenders
  const currentView = useMemo(() => {
    return (
      <div>
        <CalendarHeader />
        {view === "week" && (
          <WeeklyView
            classSessions={classSessions}
            onEventClick={onEventClick}
            isLoading={isLoading}
          />
        )}
        {view === "day" && (
          <DailyView
            isAdmin={false}
            events={classSessions}
            onEventClick={onEventClick}
            isLoading={isLoading}
          />
        )}
        {view === "agenda" && (
          <WeeklyAgendaView
            events={classSessions}
            onEventClick={onEventClick}
            onWaitlistJoin={onWaitlistJoin}
            isLoading={isLoading}
          />
        )}
      </div>
    );
  }, [classSessions, handleIconClick, isLoading, onEventClick, view]);

  return currentView;
};

export default BaseCalendarView;
